import ActionCable from 'actioncable'

let cable: ActionCable.Cable | null = null
export function getCable (): any {
  if (!cable) {
    const cableTag = document.getElementsByName('action-cable-uri')[0] as HTMLMetaElement
    cable = ActionCable.createConsumer(cableTag.content)
  }
  return cable
}
